import { useContext } from "react";
import Cookies from "js-cookie";
import { get } from "lodash";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";

import { findPostLoginRoute } from "../utils/findPostLoginRoute";
import authenticateSSOUser from "../GraphQL/Mutation/authenticateSSOUser";
import { CurrentLanguageContext } from "../Context/CurrentLanguageContext/CurrentLanguageContext";

export function useLoginAndRedirect() {
  // Set up authenticate mutation
  const [authenticate] = useMutation(authenticateSSOUser);

  // Get the current language
  const { currentLanguage } = useContext(CurrentLanguageContext);

  // Get router history
  const history = useHistory();

  /**
   * @param {object} args
   * @param {string} args.email
   * @param {string} args.password
   * @param {string} args.redirectLocation
   * @returns {Promise<void>}
   */
  async function loginAndRedirect({ email, password, redirectLocation }) {
    // Try to login, set component error state if unsuccesful
    // No try catch as we want this function to fail if authenticate failes
    const authData = await authenticate({
      variables: {
        email: email,
        password: password,
        prefferedLanguage: currentLanguage,
        redirectLocation,
      },
    });

    // Get the redirect location
    const redirect = get(
      authData,
      "data.authenticateSSOUser.redirectLocation",
      null
    );

    // Set necessary SSO cookie values
    Cookies.set(
      "access_level",
      get(authData, "data.authenticateSSOUser.SSOAccountRole", null)
    );
    Cookies.set(
      "primary_account",
      get(authData, "data.authenticateSSOUser.primaryAccountId", null)
    );

    // Go to the redirect url if provided
    if (redirect) {
      return window.location.assign(redirect);
    }

    // otherwise go to the default SSO page
    const newNavRoute = findPostLoginRoute(
      get(authData, "data.authenticateSSOUser.SSOAccountRole", null)
    );

    history.push(newNavRoute);
  }

  return loginAndRedirect;
}
